import { h, defineComponent, computed } from 'vue';
import { Modal, modalProps, ModalProps } from '@/ui/components/Modal';
import { button } from '@/ui/components/Button';
import { t } from '@/ui/i18n/i18n';
import { IssueDetail } from '@/entities/issue/v2';
import {
  getInspectionId,
  getPageTile,
  getQuestion,
  getResponse,
  getFirstSection,
} from '@/ui/helpers/breadcrumbHelper';
import { IssueDetailsInspectionContent } from '@/ui/pages/issue/issueDetailsModal/IssueDetailsInspectionContent';
import { IssueType } from '@/entities/issue';
import { IssueDetailsSensorContent } from '@/ui/pages/issue/issueDetailsModal/IssueDetailsSensorContent';

interface IssueDetailsModalProps extends ModalProps {
  issue: IssueDetail;
}

export const IssueDetailsModal = defineComponent<IssueDetailsModalProps>({
  name: 'IssueDetailsModal',
  props: [...modalProps, 'issue'],
  setup(props, context) {
    const closeModal = () => {
      context.emit('close');
    };

    const inspectionDetails = computed(() => ({
      inspectionId: props.issue ? getInspectionId(props.issue)?.toString() : '-',
      inspectionTitle: props.issue.data.inspectionTitle || props.issue.data.inspection?.title || '-',
      pageTitle: props.issue ? getPageTile(props.issue) : '-',
      sectionTitle: props.issue ? getFirstSection(props.issue) : '-',
      question: props.issue ? getQuestion(props.issue) : '-',
      response: props.issue ? getResponse(props.issue) : '-',
    }));

    const sensorDetails = computed(() => ({
      name: props.issue?.data?.payload?.sensor_title ?? '-',
      metric: props.issue?.data?.payload?.metric ?? '-',
      value: props.issue?.data?.payload?.value ?? null,
      timestamp: props.issue?.data?.payload?.timestamp ?? null,
    }));

    return function render() {
      const modalContent = () => [
        props.issue?.data.type === IssueType.Sensor
          ? h(IssueDetailsSensorContent, {
            props: {
              ...sensorDetails.value,
            },
          })
          : h(IssueDetailsInspectionContent, {
            props: {
              ...inspectionDetails.value,
            },
          }),
      ];

      return h(Modal, {
        props: {
          ...props,
          customClass: 'issue-details-modal',
          width: '400px',
          ariaRole: 'dialog',
          trapFocus: true,
          destroyOnHide: false,
          ariaModal: true,
        },
        scopedSlots: {
          actions: () => h('div', [
            button(t('common.close'), closeModal),
          ]),
        },
        on: {
          close: closeModal,
        },
      }, modalContent());
    };
  },
});
